module.exports = __webpack_public_path__ + "static/img/weixin.c4e2caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.jpg
// module id = /bMT
// module chunks = 14